import { forwardRef, type ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "ghost" | "danger-ghost";
type Size = "sm" | "md";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const base = "inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-accent-500/60 disabled:opacity-50 disabled:cursor-not-allowed";

const variants: Record<Variant, string> = {
  primary: "bg-accent-500 text-white hover:bg-accent-600 active:bg-accent-700 border border-transparent",
  secondary: "bg-white text-gray-800 border border-gray-300 hover:bg-gray-50",
  ghost: "bg-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-100 border border-transparent",
  "danger-ghost": "bg-transparent text-gray-600 border border-transparent hover:text-red-700 hover:bg-red-50",
};

const sizes: Record<Size, string> = {
  sm: "text-xs px-2.5 py-1.5",
  md: "text-sm px-3.5 py-2",
};

export const Button = forwardRef<HTMLButtonElement, Props>(
  ({ className = "", variant = "secondary", size = "md", ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
        {...rest}
      />
    );
  }
);
Button.displayName = "Button";
